import { render } from "./DataTableMixins.vue?vue&type=template&id=16554f98"
import script from "./DataTableMixins.vue?vue&type=script&lang=js"
export * from "./DataTableMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__